import { GtmEvents } from '@/gtm/gtm-events';

export class ProductListItemGtmEvents extends GtmEvents {
  eventCategory = 'СобытияВКаталоге';

  onRedirectToProductCard(data) {
    return this.gtmEvent({
      eventAction: 'Каталог_ПереходВКарточку',
      eventLabel: JSON.stringify(data),
    });
  }

  onClickSizeBtn(data) {
    return this.gtmEvent({
      eventAction: 'Каталог_ПереходВКарточку_Размер',
      eventLabel: JSON.stringify(data),
    });
  }

  onClickFavoriteBtn(data) {
    return this.gtmEvent({
      eventAction: 'Каталог_ДобавитьВИзбранное',
      eventLabel: JSON.stringify(data),
    });
  }

  onClickBasketBtn(data) {
    return this.gtmEvent({
      eventAction: 'Каталог_Корзина',
      eventLabel: JSON.stringify(data),
    });
  }

  onClickBasketAndSizeBtn(data) {
    return this.gtmEvent({
      eventAction: 'Каталог_Корзина_Размер',
      eventLabel: JSON.stringify(data),
    });
  }

  onClickBasketAndSizeBtnSuccess(data) {
    return this.gtmEvent({
      eventAction: 'Каталог_Корзина_ДобавитьВКорзину',
      eventLabel: JSON.stringify(data),
    });
  }

  onClickPageUpBtn() {
    return this.gtmEvent({
      eventAction: 'Каталог_Наверх',
    });
  }

  onClickColorBtn(data) {
    return this.gtmEvent({
      eventAction: 'Каталог_Цвет',
      eventLabel: JSON.stringify(data),
    });
  }
}
